import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";

const About = () => {
  return (
    <Box sx={{ backgroundColor: "#121212", color: "white", minHeight: "100vh", padding: 4 }}>
      {/* Hero Section */}
      <Box sx={{ textAlign: "center", marginBottom: 10 }}>
        <Typography
          variant="h3"
          sx={{ fontWeight: "bold", marginBottom: 2, lineHeight: 1.4 }}
        >
          We’re Crafting the Future of Data-Driven Decision Making
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "rgba(255, 255, 255, 0.7)", marginBottom: 4, maxWidth: "700px", margin: "0 auto" }}
        >
          Datakeet is the analytics platform designed for businesses that care about quality and insights. From
          cohort analysis to marketing optimization, we empower you to act smarter, faster.
        </Typography>
        <Button
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#4caf50",
            color: "white",
            textTransform: "none",
            padding: "10px 20px",
            "&:hover": {
              backgroundColor: "#45a049",
            },
          }}
        >
          Get Started
        </Button>
      </Box>

      {/* Features Section */}
      <Box sx={{ marginBottom: 10 }}>
        <Typography
          variant="h4"
          align="center"
          sx={{ fontWeight: "bold", marginBottom: 6 }}
        >
          Why Datakeet?
        </Typography>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 2 }}>
                Cohort Analysis
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "rgba(255, 255, 255, 0.7)", maxWidth: "280px", margin: "0 auto" }}
              >
                Dive into customer retention and engagement trends over time to optimize your business strategy.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 2 }}>
                Seamless Integrations
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "rgba(255, 255, 255, 0.7)", maxWidth: "280px", margin: "0 auto" }}
              >
                Connect with Shopify, Meta Ads, and Google Ads to centralize your data for smarter insights.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 2 }}>
                Actionable Insights
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "rgba(255, 255, 255, 0.7)", maxWidth: "280px", margin: "0 auto" }}
              >
                Access tailored recommendations to meet your goals and drive impactful decisions.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Mission Section */}
      <Box sx={{ textAlign: "center", marginBottom: 10 }}>
        <Typography variant="h4" sx={{ fontWeight: "bold", marginBottom: 4 }}>
          Our Mission
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: "rgba(255, 255, 255, 0.7)", maxWidth: "700px", margin: "0 auto" }}
        >
          At Datakeet, our mission is to make analytics accessible to businesses of all sizes. We simplify the
          complex, enabling teams to unlock their full potential and make smarter, data-driven decisions.
        </Typography>
      </Box>

      {/* Footer */}
      <Box sx={{ textAlign: "center", padding: 2, borderTop: "1px solid rgba(255, 255, 255, 0.1)" }}>
        <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.5)" }}>
          &copy; {new Date().getFullYear()} Datakeet. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default About;
